import React from "react";

function Show(){
    return (
        <>showing something</>
    )
}
export default Show;